export const rightsConfig = [
  {
    key: "tenant",
    label: "Housing & Rent",
    roles: [
      { key: "tenant", label: "Tenant" },
      { key: "homeowner", label: "Homeowner" },
      { key: "buyer", label: "Buyer" },
    ],
    issues: [
      "Rent & Payment",
      "Eviction",
      "Deposit",
      "Housing conditions",
    ],
  },
  {
    key: "employee",
    label: "Employment & Work",
    roles: [
      { key: "employee", label: "Employee" },
      { key: "freelancer", label: "Freelancer" },
      { key: "job-applicant", label: "Job applicant" },
    ],
    issues: [
      "Salary & Wages",
      "Termination",
      "Contract terms",
      "Workplace conditions",
      "Discrimination",
    ],
  },
  {
    key: "consumer",
    label: "Consumer Rights",
    roles: [
      { key: "consumer", label: "Consumer" },
    ],
    issues: [
      "Defective product",
      "Refund / Return",
      "Warranty",
      "Misleading information",
    ],
  },
  {
    key: "student",
    label: "Education & Students",
    roles: [
      { key: "student", label: "Student" },
    ],
    issues: [
      "Grades & exams",
      "Tuition fees",
      "Admission issues",
      "Disciplinary actions",
    ],
  },
  {
    key: "family",
    label: "Family & Personal Status",
    roles: [
      { key: "individual", label: "Individual" },
      { key: "parent", label: "Parent" },
    ],
    issues: [
      "Marriage",
      "Divorce",
      "Custody",
      "Inheritance",
    ],
  },
  {
    key: "healthcare",
    label: "Healthcare & Medical",
    roles: [
      { key: "patient", label: "Patient" },
    ],
    issues: [
      "Medical treatment",
      "Insurance coverage",
      "Privacy of records",
    ],
  },
  {
    key: "privacy",
    label: "Privacy & Digital Rights",
    roles: [
      { key: "individual", label: "Individual" },
      { key: "internet-user", label: "Internet user" },
    ],
    issues: [
      "Personal data",
      "Online privacy",
      "Social media",
    ],
  },
  {
    key: "contracts",
    label: "Contracts & Agreements",
    roles: [
      { key: "individual", label: "Individual" },
      { key: "business-owner", label: "Business owner" },
    ],
    issues: [
      "Signing contracts",
      "Unclear terms",
      "Breach of agreement",
    ],
  },
  {
    key: "business",
    label: "Business & Commercial",
    roles: [
      { key: "business-owner", label: "Business owner" },
      { key: "entrepreneur", label: "Entrepreneur" },
    ],
    issues: [
      "Company setup",
      "Commercial contracts",
      "Competition",
    ],
  },
  {
    key: "immigration",
    label: "Immigration",
    roles: [
      { key: "immigrant", label: "Immigrant" },
      { key: "applicant", label: "Applicant" },
    ],
    issues: [
      "Visa",
      "Residency",
      "Citizenship",
      "Deportation",
    ],
  },
  {
    key: "criminal",
    label: "Criminal Matters",
    roles: [
      { key: "individual", label: "Individual" },
    ],
    issues: [
      "Arrest",
      "Police interaction",
      "Trial",
    ],
  },
  {
    key: "tax",
    label: "Taxation",
    roles: [
      { key: "taxpayer", label: "Taxpayer" },
    ],
    issues: [
      "Tax filing",
      "Deductions",
      "Tax disputes",
    ],
  },
  {
    key: "banking",
    label: "Banking & Financial Services",
    roles: [
      { key: "customer", label: "Customer" },
    ],
    issues: [
      "Account issues",
      "Transactions",
      "Fees",
    ],
  },
  {
    key: "insurance",
    label: "Insurance",
    roles: [
      { key: "policyholder", label: "Policyholder" },
    ],
    issues: [
      "Claims",
      "Coverage",
      "Policy terms",
    ],
  },
  {
    key: "elderly",
    label: "Elderly Rights",
    roles: [
      { key: "senior", label: "Senior" },
    ],
    issues: [
      "Pension",
      "Elder care",
      "Discrimination",
    ],
  },
  {
    key: "disability-rights",
    label: "Disability Rights",
    roles: [
      { key: "individual", label: "Individual" },
    ],
    issues: [
      "Accessibility",
      "Accommodation",
      "Discrimination",
    ],
  },
];
export default rightsConfig;